import { render, staticRenderFns } from "./repartition-surfaces.vue?vue&type=template&id=2257211c&scoped=true"
import script from "./repartition-surfaces.vue?vue&type=script&lang=js"
export * from "./repartition-surfaces.vue?vue&type=script&lang=js"
import style0 from "./repartition-surfaces.vue?vue&type=style&index=0&id=2257211c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257211c",
  null
  
)

export default component.exports